import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import FlowDiagram from "@/components/site/FlowDiagram";
import HowItWorks from "@/components/site/HowItWorks";
import Pricing from "@/components/site/Pricing";
import FAQ from "@/components/site/FAQ";
import FinalCTA from "@/components/site/FinalCTA";
import Footer from "@/components/site/Footer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#09090B]" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <FlowDiagram />
        <HowItWorks />
        <Pricing />
        <FAQ />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
